<template>
  <div class="max-w-md mx-auto mt-8 bg-white p-6 rounded-xl shadow-md">
    <h2 class="text-2xl font-bold mb-4">Login</h2>

    <!-- OIDC Login Button -->
    <div v-if="oidcConfig?.enabled" class="mb-6">
      <p class="mb-3 text-sm text-gray-600">
        Please click the “Sign in with HTWG account (OIDC)” button to log in with your university account.
      </p>
      <button 
        @click="loginWithKeycloak" 
        type="submit" class="btn"
      >
        Sign in with HTWG account (OIDC)
      </button>
      
      <div class="flex items-center my-4">
        <div class="flex-grow border-t border-gray-300"></div>
        <span class="px-3 text-gray-500 text-sm">oder</span>
        <div class="flex-grow border-t border-gray-300"></div>
      </div>
    </div>

    <!-- Local Login Form -->
    <form @submit.prevent="submitForm" class="space-y-4">
      <input
        v-model="credentials.email"
        type="email"
        placeholder="Email"
        class="input"
        required
      />
      <input
        v-model="credentials.password"
        type="password"
        placeholder="Password"
        class="input"
        required
      />
      <button type="submit" class="btn">Login</button>
    </form>
    <p v-if="error" class="text-red-500 mt-2">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { loginUser } from "@/api/auth";
import { useAuth } from "@/stores/auth";
import { useOIDC } from "@/composables/useOIDC";

const auth = useAuth();
const router = useRouter();
const { oidcConfig, loadOIDCConfig, initiateOIDCLogin } = useOIDC();

const credentials = ref({
  email: "",
  password: "",
});
const error = ref(null);

// Load OIDC config on mount
onMounted(async () => {
  await loadOIDCConfig();
});

async function submitForm() {
  try {
    const response = await loginUser(credentials.value);
    const { access_token, refresh_token } = response.data;

    // Pass both tokens to auth store
    auth.login(access_token, refresh_token);

    router.push("/");
  } catch (err) {
    console.error("Login error:", err);
    error.value = err.response?.data?.detail || "Login failed";
  }
}

async function loginWithKeycloak() {
  try {
    await initiateOIDCLogin();
  } catch (err) {
    console.error("Keycloak login error:", err);
    error.value = err.message || "Keycloak login failed";
  }
}
</script>

<style scoped>
.input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
}
.btn {
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #4f46e5;
  color: white;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
}
.btn:hover {
  background-color: #4338ca;
}
.btn-keycloak {
  padding: 0.5rem 1rem;
  background-color: #008aaa;
  color: white;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}
.btn-keycloak:hover {
  background-color: #006d87;
}
</style>
